/**
 * Continuous Futures Contract Types
 *
 * Defines types for continuous futures contracts with roll logic and back-adjustment.
 * Supports multiple roll methods: Ratio, Panama (Cumulative Difference), Backward Ratio.
 */
/** Default roll configurations for known VN futures */
export const DEFAULT_VN_FUTURES_ROLL_CONFIG = {
    "VN30F1M": {
        rootSymbol: "VN30F",
        rollMethod: "ratio",
        rollTrigger: "days-before-expiry",
        rollDaysBeforeExpiry: 3,
        adjustVolumes: true,
    },
    "VN30F1M-panama": {
        rootSymbol: "VN30F",
        rollMethod: "panama",
        rollTrigger: "days-before-expiry",
        rollDaysBeforeExpiry: 3,
        adjustVolumes: true,
    },
    "VN30F3M": {
        rootSymbol: "VN30F",
        rollMethod: "ratio",
        rollTrigger: "days-before-expiry",
        rollDaysBeforeExpiry: 5,
        adjustVolumes: true,
    },
};
